// Component to render serialised apckdata.reporting.markdown
// TODO: test and add the remaining components

const TextElement = {
    props: {
        content: {
            type: Object,
        },
    },
    template: `<p>{{ content.text }}</p>`,
};

const HeadingElement = {
    props: {
        content: {
            type: Object,
        },
    },
    template: `<h3>{{ content.text }}</h3>`,
};

const BulletsElement = {
    props: {
        content: {
            type: Object,
        },
    },
    template: `
    <ul v-if="!content.numbered">
      <li v-for="item in content.bullets">{{ item }}</li>
    </ul>
    <ol v-else>
      <li v-for="item in content.bullets">{{ item }}</li>
    </ol>
  `,
};

const TableElement = {
    props: {
        content: {
            type: Object,
        },
    },
    template: `
    <table>
      <thead>
        <tr>
          <th v-for="(item, index) in content.headings" :key="index">{{ item }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, row_index) in content.data" :key="row_index">
          <td v-for="(cell, cell_index) in row" :key="cell_index">{{ cell }}</td>
        </tr>
      </tbody>
    </table>
  `,
};

export const ApckDataMarkdown = {
    props: {
        elements: {
            type: Array,
            default: () => [],
        },
    },

    components: {
        'text-element': TextElement,
        'heading-element': HeadingElement,
        'table-element': TableElement,
        'bullets-element': BulletsElement,
    },

    computed: {
        normalisedElements() {
            return this.elements.map((el) => ({
                type: el[0],
                content: el[1],
            }));
        },
    },

    methods: {
        getComponent(type) {
            const componentMap = {
                text: 'text-element',
                heading: 'heading-element',
                table: 'table-element',
                bullets: 'bullets-element',
            };

            return componentMap[type] || null;
        },
    },

    template: `
    <div class="apck-narrative__markdown c-vuln-details-module">
      <component
        v-for="(item, index) in normalisedElements"
        :is="getComponent(item.type)"
        :key="index"
        :content="item.content"
      />
    </div>
  `,
};
